import React, { PureComponent } from 'react';
import styles from './RenderReview.module.css';
import Button from '../Button';
import Image from '../Image';
import Divider from '../Divider';
export default class RenderReview extends PureComponent {
  render() {
    const { output, hideBtn } = this.props;
    const { title, result, swatch, diffuse } = output;
    return (
      <div className={styles.container}>
        <Divider />
        <div className={styles.headerContainer}>
          <div className={styles.title}>{title} </div>
          {!hideBtn && (
            <div className={styles.btnContainer}>
              <Button white style={{ marginRight: 15 }} text="Reject" />
              <Button text="Approve" />
            </div>
          )}
        </div>
        <div className={styles.content}>
          <Image className={styles.renderResult} image={result} />
          <div className={styles.swatchReference}>
            <Image className={styles.orginalSwatch} image={swatch} />
            <Image className={styles.diffuseMap} image={diffuse} />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/RenderReview/index.js